import React, { useEffect, useState } from 'react';
import { SecurityOperationsCenter } from '../components/security/SecurityOperationsCenter'
import { MobileSecurity } from './MobileSecurity';

export const SecurityPage: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // Match lg breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return <MobileSecurity />;
  }

  return (
    <div className="space-y-6">
      <SecurityOperationsCenter />
    </div>
  );
};